<script>
  import ProductImage from './ProductImage.svelte';
  import determineProductColourImageUrl from '../../src/utils/determineProductColourImageUrl.js';
  import ImagePlaceHolder from './ImagePlaceHolder.svelte';

  import { onMount } from 'svelte';

  export let templateDetails;
  export let productRootSlug;
  export let productSlug;
  export let colourObject;

  let templateImageUrl;

  onMount(async () => {
    templateImageUrl = await determineProductColourImageUrl({
      productSlug: productRootSlug,
      colourPathName: colourObject.pathName,
      colourObject: colourObject,
      imageSize: 256,
      imageType: 'webp',
      gender: 'mens',
      side: 'front',
      showModel: true,
      isModelBasedImages: false,
      sublimationTemplateId: templateDetails.SublimationTemplate?.id,
    });
  });
</script>

{#if !templateImageUrl}
  <ImagePlaceHolder width={'256px'} height={'312px'} />
{/if}
{#if templateImageUrl}
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="image-container">
    <a href={`/design/${productSlug}/choose-template`}>
      <ProductImage src={templateImageUrl} height={'100%'} width={'auto'} />
    </a>
  </div>
{/if}

<style>
  .image-container {
    display: flex;
    justify-content: center;
    cursor: pointer;
  }
</style>
